
import React from 'react';

const SelfieUnderline = () => {
	return (
		<svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path d='M22 4H10V6H22V4Z' fill='#2d2d2d'/>
			<path d='M27 6C25.87 6 24.84 6.39 24 7.03V3C24 1.9 23.1 1 22 1H9C7.9 1 7 1.9 7 3V5C5.35 5 4 6.35 4 8C4 8.77 4.3 9.47 4.78 10C4.3 10.53 4 11.23 4 12C4 12.77 4.3 13.47 4.78 14C4.3 14.53 4 15.23 4 16C4 16.77 4.3 17.47 4.78 18C4.3 18.53 4 19.23 4 20C4 21.65 5.35 23 7 23C7 24.1 7.9 25 9 25H22H23C25.76 25 28 22.76 28 20V7C28 6.45 27.55 6 27 6ZM7 21C6.45 21 6 20.55 6 20C6 19.45 6.45 19 7 19V21ZM7 17C6.45 17 6 16.55 6 16C6 15.45 6.45 15 7 15V17ZM7 13C6.45 13 6 12.55 6 12C6 11.45 6.45 11 7 11V13ZM7 9C6.45 9 6 8.55 6 8C6 7.45 6.45 7 7 7V9ZM22 3V10.99V11V14V19H9V3H22ZM9 23V21H22V23H9ZM26 20C26 21.3 25.16 22.4 24 22.82V14V11C24 9.7 24.84 8.58 26 8.17V20Z' fill='#2d2d2d'/>
			<path d='M18 9.5C18 8.12 16.88 7 15.5 7C14.12 7 13 8.12 13 9.5C13 10.88 14.12 12 15.5 12C16.88 12 18 10.88 18 9.5ZM15 9.5C15 9.22 15.22 9 15.5 9C15.78 9 16 9.22 16 9.5C16 9.78 15.78 10 15.5 10C15.22 10 15 9.78 15 9.5Z' fill='#2d2d2d'/>
			<path d='M15.5 13C12.93 13 11 14.72 11 17C11 17.55 11.45 18 12 18H19C19.55 18 20 17.55 20 17C20 14.72 18.07 13 15.5 13ZM13.3 16C14.19 14.68 16.81 14.68 17.7 16H13.3Z' fill='#2d2d2d'/>
			<path d='M25 29H7V31H25V29Z' fill='#2d2d2d'/>
		</svg>
	);
};

export default SelfieUnderline;
